import { all } from 'redux-saga/effects';
import authSagas from 'reduxStore/auth/saga';
import bookingSagas from 'reduxStore/bookings/saga';
import categoriesSagas from 'reduxStore/categories/saga';
import defaultSettingsSagas from 'reduxStore/defaultSettings/saga';
import devicesSagas from 'reduxStore/devices/saga';
import FBRemoteConfigSagas from 'reduxStore/fbRemoteConfig/saga';
import floorsSagas from 'reduxStore/floors/saga';
import maintenanceSagas from 'reduxStore/maintenance/saga';
import organisationSaga from 'reduxStore/organisations/saga';
import peopleSagas from 'reduxStore/people/saga';
import settingsSagas from 'reduxStore/settings/saga';
import sitesSagas from 'reduxStore/sites/saga';
import teamsSagas from 'reduxStore/teams/saga';
import typesSagas from 'reduxStore/types/saga';
import accessLogs from './accessLogs/saga';
import appSagas from './app/saga';
import assetGroupSagas from './assetGroups/saga';
import credentialsSagas from './credentials/saga';
import defaultCategoriesSagas from './defaultCategories/saga';
import inventorySagas from './inventory/saga';
import lockersLogs from './lockersLogs/saga';
import mapSaga from './maps/saga';
import permissionsSagas from './permissions/saga';
import rolesSagas from './roles/saga';
import innerRangeSagas from './innerRange/saga';
import controlSagas from './control/saga';

function* rootSaga(getState) {
	yield all([
		accessLogs(),
		lockersLogs(),
		authSagas(),
		assetGroupSagas(),
		defaultCategoriesSagas(),
		categoriesSagas(),
		bookingSagas(),
		devicesSagas(),
		defaultSettingsSagas(),
		floorsSagas(),
		FBRemoteConfigSagas(),
		maintenanceSagas(),
		peopleSagas(),
		sitesSagas(),
		settingsSagas(),
		teamsSagas(),
		typesSagas(),
		organisationSaga(),
		inventorySagas(),
		appSagas(),
		credentialsSagas(),
		permissionsSagas(),
		mapSaga(),
		rolesSagas(),
		innerRangeSagas(),
		controlSagas()
	]);
}
export default rootSaga;
